import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import CustomVideoPlayer from '../../../src/components/custom-video-player';
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/67d89861-7a1e-4df9-a801-01d11f4dfb17",
        "alt": "The text component has size ranges from 100 to 700 with 100 being the smallest, and 700 being the largest."
      }}></img></p>
    <h2>{`Usage`}</h2>
    <p>{`Use the text component to provide content and a clear hierarchy structure. The text component renders an HTML `}<inlineCode parentName="p">{`<span>`}</inlineCode>{` tag without any default styling. Use `}<inlineCode parentName="p">{`<p>`}</inlineCode>{` for any text that is meant to be a paragraph of text. Use multiple text components to represent paragraphs as distinct blocks of text. This helps with readability and makes it easier for search engines and assistive technologies to understand the content.`}</p>
    <h2>{`Options`}</h2>
    <h3>{`Variant`}</h3>
    <p>{`The text component provides two variant options: `}<inlineCode parentName="p">{`default`}</inlineCode>{` and `}<inlineCode parentName="p">{`muted`}</inlineCode>{`. The `}<inlineCode parentName="p">{`muted`}</inlineCode>{` variant is used to de-emphasize text or to provide visual contrast when paired with a title.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/b7fa8c0d-0877-4edd-a8b3-4eea2e16fe26" />
    <Caption mdxType="Caption">
      Use muted text to de-emphasize text and provide additional context.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/01f1e3a8-5058-4a73-a69f-6f424382fb63" />
    <Caption mdxType="Caption">
      Don't use standalone muted text. Muted text should always be paired with
      emphasized text or a title.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Size`}</h3>
    <p>{`The text size ranges from 100 to 700, with 400 as the default size. This scale is built to provide hierarchy for all types of scenarios.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/e029b053-eab8-47a7-bd49-b6ce49ac8bdf" />
    <Caption mdxType="Caption">
      Use a smaller size to provide visual hierarchy when the text is paired
      with a title. Use as many text components as needed to represent different
      blocks of content.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/bfc9aaba-5a48-4053-a4a0-2209a9d7f082" />
    <Caption mdxType="Caption">
      When the text is paired with a title, use a smaller size to provide visual
      hierarchy.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Alignment`}</h3>
    <p>{`Text alignment options offer a convenient way to control the positioning of content within block level elements.`}</p>
    <p>{`Available options include `}<inlineCode parentName="p">{`start`}</inlineCode>{`, `}<inlineCode parentName="p">{`center`}</inlineCode>{`, and `}<inlineCode parentName="p">{`end`}</inlineCode>{`, which are recommended for supporting bidirectional reading.`}</p>
    <h3>{`Weight`}</h3>
    <p>{`The text component also supports `}<inlineCode parentName="p">{`weight`}</inlineCode>{` options. Weight is automatically determined by the text size, but can be overridden when the scenario calls for it.`}</p>
    <h3>{`Responsive`}</h3>
    <p>{`The text component is responsive by default and the size will scale down on smaller screens. Weight options will remain the same across all screen sizes but can be overridden for each breakpoint.`}</p>
    <div>
  <CustomVideoPlayer width="100%" src="https://github.com/primer/brand/assets/912236/f14167c9-2acc-4e7b-9d3d-a722e8a61e7f" mdxType="CustomVideoPlayer" />
    </div>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Heading"
        }}>{`Heading`}</a>{`: to render headings.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/OrderedList"
        }}>{`Ordered list`}</a>{`: to render ordered lists.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/UnorderedList"
        }}>{`Unordered list`}</a>{`: to render unordered lists.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      